import React from 'react'
import { ColumnMappingEnum } from 'api'
import { DataHelper } from 'model'
import { ComboboxField } from 'view/components/options'
import { LabelPosition } from 'view/styles/constants'
import { getAllHeadings } from '../model'
import { ColumnMappingPanelProps, ColumnMappingPanel } from './ColumnMappingPanel'
import { EnumValuesPanel } from './EnumValuesPanel'

interface ColumnMappingEnumPanelProps<T> extends ColumnMappingPanelProps<ColumnMappingEnum<T>> {
  Enum: T
  enumHelper: DataHelper<T>
  excludeValues?: T[]
}

export const ColumnMappingEnumPanel: React.FunctionComponent<ColumnMappingEnumPanelProps<any>> = props => {
  const { excludeValues = [], fieldTitle, fieldName, columnMapping, parseResult, Enum, enumHelper, onUpdate } = props

  const handleUpdateHeading = (heading: string) => onUpdate({ ...columnMapping, heading }, fieldName)

  const handleUpdateValues = (values: { [index: string]: string }) => onUpdate({ ...columnMapping, values }, fieldName)

  return (
    <ColumnMappingPanel>
      <ComboboxField
        label={fieldTitle}
        labelPosition={LabelPosition.Left}
        optionKeys={getAllHeadings(parseResult.rows)}
        value={columnMapping.heading}
        validationField={fieldTitle}
        validationIssues={parseResult.issues}
        canClear={true}
        onUpdate={handleUpdateHeading}
      />
      <EnumValuesPanel
        Enum={Enum}
        enumHelper={enumHelper}
        excludeValues={excludeValues}
        values={columnMapping.values}
        onUpdate={handleUpdateValues}
      />
    </ColumnMappingPanel>
  )
}
